import DiegoHernandez from '../imgs/Diego Hernández Landeros.jfif';
import JorgeGarcia from '../imgs/JORGE GARCÍA.jpg';
import DavidFranco from '../imgs/DAVID FRANCO.jpg';
import AdamJacobo from '../imgs/Adam Jacobo Espinosa Tinoco.jfif';
import JosueCastaneda from '../imgs/Josué Castañeda Landa.jpeg';
import RodrigoGomez from '../imgs/Rodrigo Gómez Ramírez.jpeg';
import ClaudiaMartinez from '../imgs/Claudia Martínez Martínez.jpeg';
import JuanCarlosRendon from '../imgs/JC Rendon.jpeg';
import AnaDeliaGayosso from '../imgs/Ana Delia Gayosso.jpeg';
import DiegoRomero from '../imgs/DiegoRomeroMora.png';
import JoseRicardoMendoza from '../imgs/Jose Ricardo Mendoza Villar.png';
import GeneralMentor from '../imgs/mentor.png';
import AdolfoUlisesCastro from '../imgs/Adolfo Castro.jpeg';
import ArturoSoto from '../imgs/Arturo Soto.jpeg';
import JuanMarmolejo from '../imgs/Juan Marmolejo.jpeg';
import CarlosTena from '../imgs/Carlos Alberto Gallegos Tena.jpeg';
import AristeoBenjamín from '../imgs/Aristeo Benjamín Gómez Sainz.jpeg';
import DanielCordero from '../imgs/Daniel Cordero Vazquez.jpeg';
import AliPeralta from '../imgs/Ali Alderete Peralta.jpeg';
import EnriqueMendoza from '../imgs/Enrique Alberto Mendoza Ruíz.jpeg';
import FranciscoArguelles from '../imgs/Francisco Arguelles Arredondo.jpeg';
import HectorGutierrez from '../imgs/Héctor Gutérrez Machorro.jfif';
import MaryMartinez from '../imgs/Mary José Martínez Castillo.jpeg';
import MiguelMoran from '../imgs/Miguel Ángel Moran Flores.jpg';
import StefanniOrozco from '../imgs/Stefanni Yadira Orozco Inés.jpeg';

export const mentors = [
  {
    id: 1,
    name: 'Diego Romero Mora',
    company: 'Teradata',
    position: 'Senior AI Automation Engineer',
    linkedin: 'https://www.linkedin.com/in/diego-romero-mora-1094a41a2/',
    image: DiegoRomero,
  },
  {
    id: 2,
    name: 'Jose Ricardo Mendoza Villar',
    company: 'Oracle',
    position: 'AI Cloud Engineer',
    linkedin: 'https://www.linkedin.com/in/richi1325/',
    image: JoseRicardoMendoza,
  },
  {
    id: 3,
    name: 'Diego Hernández Landeros',
    company: 'CISCO',
    position: 'Security Consulting Engineer',
    linkedin: 'https://www.linkedin.com/in/diego-hzl',
    image: DiegoHernandez,
  },
  {
    id: 4,
    name: 'Jorge Antonio Garcia Galicia',
    company: 'Google LLC',
    position: 'Senior Software Engineer',
    linkedin: 'https://www.linkedin.com/in/jorgegarciagalicia/',
    image: JorgeGarcia,
  },
  {
    id: 5,
    name: 'David Franco Pérez',
    company: 'Spectramind Solutions',
    position: 'Director y fundador',
    linkedin: 'https://www.linkedin.com/in/david-francomx/',
    image: DavidFranco,
  },
  {
    id: 6,
    name: 'Adam Jacobo Espinosa Tinoco',
    company: 'Acxiom',
    position: 'Expert Solution Developer',
    linkedin: 'https://www.linkedin.com/in/adam-espinosa-8b0a1660',
    image: AdamJacobo,
  },
  {
    id: 7,
    name: 'Josué Castañeda Landa',
    company: 'Konfio',
    position: 'Senior Data Engineer',
    linkedin: 'https://www.linkedin.com/in/josu%C3%A9-casta%C3%B1eda-landa-b2216b14a/',
    image: JosueCastaneda,
  },
  {
    id: 8,
    name: 'Rodrigo Gómez Ramírez',
    company: 'Walmart',
    position: 'Senior Manager Datos de logística',
    linkedin: '',
    image: RodrigoGomez,
  },
  {
    id: 9,
    name: 'Claudia Martínez Martínez',
    company: 'BBVA México',
    position: 'Project Manager de IA',
    linkedin: 'https://www.linkedin.com/in/claudia-m-17a72929',
    image: ClaudiaMartinez,
  },
  {
    id: 10,
    name: 'Juan Carlos Rendón Aguilar',
    company: 'GōkuLab',
    position: 'CEO',
    linkedin: 'https://www.linkedin.com/in/jcrendon0909',
    image: JuanCarlosRendon,
  },
  {
    id: 11,
    name: 'Ana Delia Gayosso',
    company: 'Multinacional del sector textil',
    position: 'Responsable de Forecasting',
    linkedin: '',
    image: AnaDeliaGayosso,
  },
  {
    id: 12,
    name: 'Carlos Alberto Gallegos Tena',
    company: 'M&A UK',
    position: 'AI Engineer',
    linkedin: 'https://mx.linkedin.com/in/carlos-alberto-gallegos-tena-95271224a',
    image: CarlosTena,
  },
  {
    id: 13,
    name: 'Jesús Daniel Cordero Vázquez',
    company: 'BBVA Technology America',
    position: 'Information Security Senior Expert',
    linkedin: '',
    image: DanielCordero,
  },
  {
    id: 14,
    name: 'Aristeo Benjamín Gómez Sainz',
    company: 'Integración Inteligente en Sistemas de Información',
    position: 'Account Manager',
    linkedin: 'https://www.linkedin.com/in/benjamin-g%C3%B3mez-74917757/',
    image: AristeoBenjamín,
  },
  {
    id: 15,
    name: 'Enrique Mendoza Ruíz',
    company: 'Senado de la República',
    position: 'Asesor en la Comisión de Ciberseguridad del Senado de la República',
    linkedin: 'https://linkedin.com/in/kikeush',
    image: EnriqueMendoza,
  },
  {
    id: 16,
    name: 'Stefanni Yadira Orozco Inés',
    company: 'AT&T México',
    position: 'Expert Data Engineer',
    linkedin: 'https://www.linkedin.com/in/stefanni-yadira-orozco-in%C3%A9s-370769b5',
    image: StefanniOrozco,
  },
  {
    id: 17,
    name: 'Ali Alderete Peralta',
    company: 'Cranfield University',
    position: 'Professor y Director de Carrera de Ciencia de Datos',
    linkedin: 'https://www.linkedin.com/in/aldereteali/',
    image: AliPeralta,
  },
  {
    id: 18,
    name: 'Mary José Martínez Castillo',
    company: 'BBVA',
    position: 'Retail Risk Manager',
    linkedin: 'https://www.linkedin.com/in/mary-jos%C3%A9-mart%C3%ADnez-castillo-a1aa18195/',
    image: MaryMartinez,
  },
  {
    id: 19,
    name: 'Miguel Ángel Moran Flores',
    company: 'The Coca-Cola Company',
    position: 'Data Senior Manager',
    linkedin: 'https://linkedin.com/in/mikesaurio',
    image: MiguelMoran,
  },
  {
    id: 20,
    name: 'Héctor Gutiérrez Machorro',
    company: 'Konesh Soluciones',
    position: 'CEO',
    linkedin: 'https://www.linkedin.com/in/h%C3%A9ctor-guti%C3%A9rrez-ab679097/',
    image: HectorGutierrez,
  },
  {
    id: 21,
    name: 'Francisco Argüelles Arredondo',
    company: 'ExaGrid',
    position: 'Senior Systems Engineer',
    linkedin: 'https://www.linkedin.com/in/francisco-arguelles-arredondo-2424356',
    image: FranciscoArguelles,
  },
  {
    id: 22,
    name: 'Adolfo Ulises Castro Santamaria',
    company: 'Konesh Soluciones',
    position: 'Director de Gobierno Corporativo',
    linkedin: 'https://www.linkedin.com/in/adolfo-castro-49825a98',
    image: AdolfoUlisesCastro,
  },
  {
    id: 23,
    name: 'Juan Marmolejo',
    company: 'Google LLC',
    position: 'Sr. Cloud Solutions Consultant',
    linkedin: 'https://www.linkedin.com/in/juan-marmolejo-%E2%98%81%EF%B8%8F/',
    image: JuanMarmolejo,
  },
  {
    id: 24,
    name: 'Arturo Soto',
    company: 'Mad.TECH',
    position: 'Chief Technology Officer',
    linkedin: 'https://www.linkedin.com/in/arturo-antonio-soto-osornio-133516169/',
    image: ArturoSoto,
  }
];
